import React from "react";

import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";

const SortFilterList = ({
  list,
  onClick,
  title,
  key,
  sortKey,
  isAscending,
}) => {
  return (
    <div className="sortfilter_main">
      <div className="list-wrapper">
        <p className="filter-name">{title}</p>
        <ul className="list_unordered">
          {list?.map((item, index) => {
            return (
              <li
                className={
                  sortKey === item.key
                    ? "selected"
                    : "popup-list-button-animation"
                }
                onClick={() => {
                  onClick({ item, index, isSortedAscending: !isAscending });
                }}
              >
                <div className="key_container">
                  <p className="container_p"> {item.show} </p>
                  <img
                    src={
                      isAscending && sortKey === item.key
                        ? sortedIcon
                        : !isAscending && sortKey === item.key
                          ? sortedAtoz
                          : sortKey !== item.key
                            ? unsortedIcon
                            : ""
                    }
                    alt="sort"
                  />
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default SortFilterList;
